import { PageContainer } from '../../../shared/components/PageContainer';
import { FeriasPainel } from '../components/FeriasPainel';

/** Autosserviço de férias (US-GP-012/014): saldo, solicitação e acompanhamento. */
export default function MinhasFeriasPage() {
  return (
    <PageContainer title="Minhas férias" subtitle="Seus períodos, saldo, solicitações e a linha do tempo das férias.">
      <FeriasPainel scope={{ kind: 'me' }} self />
    </PageContainer>
  );
}
